import { Avatar, Box, Button, Stack, Typography } from '@mui/material';
import { IReimbursements } from 'API/Reimbursements';
import { PurpleArrowLeft } from 'Images';
import { isDesktop } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';

export interface IReimbursementsItem {
  item: IReimbursements;
}
export const Item = ({ item }: IReimbursementsItem) => {
  const navigate = useNavigate();
  return isDesktop ? (
    <Stack
      flexDirection={'row'}
      onClick={() => {
        if (item.externalLink) window.open(item.externalLink);
        else if (item.internalLink) navigate(item.internalLink);
      }}
      sx={{
        backgroundColor: '#fff',
        border: '1px solid',
        borderColor: 'primary.shade_200',
        borderRadius: '8px',
        boxShadow: '0px 1px 20px 0px #081E541A',
        cursor: 'pointer',
        p: '24px 16px',
        justifyContent: 'space-between',
        height: '111px',
      }}
    >
      <Stack flexDirection={'row'} alignItems={'center'}>
        <Avatar
          src={decodeURIComponent(item.iconUrlPath)}
          sx={{ width: '40px', height: '40px' }}
          alt=''
        />
        <Typography
          component={'h2'}
          sx={{ flexGrow: 1, ml: 1, display: 'flex', alignItems: 'center' }}
        >
          {item.name}
        </Typography>
      </Stack>

      <Button
        endIcon={
          <Avatar
            alt=''
            src={PurpleArrowLeft}
            sx={{ width: '20px', height: '20px' }}
          />
        }
        sx={{
          minWidth: '20px !important',
        }}
      ></Button>
    </Stack>
  ) : (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
      <Stack
        flexDirection={'row'}
        onClick={() => {
          if (item.externalLink) window.open(item.externalLink);
          else if (item.internalLink) navigate(item.internalLink);
        }}
        sx={{
          backgroundColor: '#fff',
          border: '1px solid',
          borderColor: 'primary.shade_200',
          borderRadius: '12px',
          boxShadow: '0px 1px 20px 0px #081E541A',
          cursor: 'pointer',
          width: 'calc(100% - 25px)',
          height: '72px',
          position: 'relative',
          alignItems: 'center',
          pl: '40px',
        }}
      >
        <Box
          sx={{
            width: '70px',
            height: '70px',
            border: '2px solid',
            borderColor: 'primary.shade_200',
            borderRadius: '50px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            left: '-30px',
            backgroundColor: '#fff',
          }}
        >
          <Avatar
            src={decodeURIComponent(item.iconUrlPath)}
            sx={{
              width: '40px',
              height: '40px',
            }}
            alt=''
          />
        </Box>
        <Typography component={'h2'} sx={{ flexGrow: 1, ml: 2 }}>
          {item.name}
        </Typography>
        <Button
          endIcon={
            <Avatar
              alt=''
              src={decodeURIComponent(PurpleArrowLeft)}
              sx={{ width: '20px', height: '20px' }}
            />
          }
        />
      </Stack>
    </Box>
  );
};
